import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationWorkflowsFetchFailedAction = {
	type: 'ORGANIZATION_WORKFLOWS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationWorkflowsFetchFailedAction => ({
	type: 'ORGANIZATION_WORKFLOWS_FETCH_FAILED',
	payload,
});
